<!--
 * @Author: Lemon C
 * @Date: 2024-12-10 16:46:11
 * @LastEditTime: 2025-03-12 11:49:01
-->
<template>
    <div class="sup-uptate-comp">
        <div class="re-w1200 re-main-col">
            <div class="type-title-box">
                <div class="title-blue-line"></div>
                <span class="title">重要更新</span>
                <img src="@/assets/imgs/devDoc/more_btn.png" @click="jump_update_click" />
            </div>
            <div class="update-list-box">
                <div
                    class="update-list-item"
                    v-for="(item, index) in important_update_list"
                    :key="`index_${index}`"
                    @click="jump_update_item_click(item)">
                    <span>{{ update_title_computed(item) }}</span>
                    <span>{{ item.secondTitle }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, onUnmounted, nextTick, watchEffect, computed, getCurrentInstance } from 'vue';
import { useRouterStore } from '@/stores/router';
import updateBgImage from '@/assets/imgs/general/gradual_change_bg.png';

const router_store = useRouterStore();
const { proxy } = getCurrentInstance();

const props = defineProps({
    important_update_list: {
        type: Array,
        default: () => [],
    },
});

onMounted(() => {});

onUnmounted(() => {
    hover_removeEventListener();
});

watchEffect(() => {
    if (props.important_update_list.length > 0) {
        nextTick(() => {
            hover_addEventListener();
            // 设置默认的hover显示
            const hoverDivs = document.querySelectorAll('.update-list-item');
            const hoverDiv = hoverDivs[0]; //默认第二个高亮
            style_change(true, hoverDiv);
        });
    }
});

const update_title_computed = computed(() => (item) => {
    let title = '';
    if (item.group == proxy.$globalObj.group.sdk) {
        title = `Engine SDK_${item.title}`;
    } else if (item.group == proxy.$globalObj.group.platform) {
        title = `自动化转换平台_${item.title}`;
    } else if (item.group == proxy.$globalObj.group.plugin) {
        title = `虫洞_${item.title}`;
    }
    return title;
});

// MARK Hover 添加悬浮处理事件
const hover_addEventListener = () => {
    const hoverDivs = document.querySelectorAll('.update-list-item');
    hoverDivs.forEach((hoverDiv) => {
        hoverDiv.addEventListener('mouseover', () => {
            hoverDivs.forEach((hoverDiv_temp) => {
                // 隐藏所有
                style_change(false, hoverDiv_temp);
            });
            // 显示目标
            style_change(true, hoverDiv);
        });
    });
};

// MARK Style 改变样式
const style_change = (hover, el) => {
    const firstChild = el.firstElementChild;
    const lastChild = el.lastElementChild;
    if (hover) {
        el.style.background = `url(${updateBgImage}) no-repeat center center / cover`;
        firstChild.style.color = 'var(--color-main-text-brand-bg-primary)';
        lastChild.style.color = 'var(--color-main-text-brand-bg-secondary)';
    } else {
        el.style.background = 'unset';
        firstChild.style.color = 'var(--color-main-text-primary)';
        lastChild.style.color = 'var(--color-main-text-secondary)';
    }
};

// MARK Hover 移除悬浮处理事件
const hover_removeEventListener = () => {
    const hoverDivs = document.querySelectorAll('.update-list-item');
    hoverDivs.forEach((hoverDiv) => {
        hoverDiv.removeEventListener('mouseover');
    });
};

// MARK Click  跳转下载与更新
const jump_update_click = () => {
    router_store.navigateToUpdatelog();
};

// MARK Click Item  跳转下载与更新
const jump_update_item_click = (item) => {
    router_store.navigateToUpdatelog({ shareType: 1, treeId: item.dcId, docId: item.id });
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-uptate-comp {
    position: relative;
    display: flex;
    justify-content: center;

    .type-title-box {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;

        .title-blue-line {
            position: relative;
            width: 6px;
            height: 48px;
            border-radius: 1px;
            background: var(--color-main-brand);
        }

        .title {
            position: relative;
            margin-left: 20px;
            height: 48px;
            flex: 1;
            font-weight: 400;
            font-size: 32px;
            color: var(--color-main-text-primary);
        }

        img {
            position: relative;
            margin-right: 0;
            width: 36px;
            height: 36px;
            cursor: pointer;
            border-radius: 18px;
            outline: 0 solid transparent;
            transition: var(--animation-outline-style);

            &:hover {
                outline: 4px solid var(--color-main-outline-hover);
            }
        }
    }

    .update-list-box {
        display: flex;
        position: relative;
        margin-top: 47px;
        width: 100%;
        height: 112px;
        background: var(--color-main-light-bg-white);
        border-radius: 10px;
        box-shadow: var(--color-main-card-shadow-small);
        overflow: hidden;

        .update-list-item {
            position: relative;
            width: 25%;
            height: 100%;
            display: flex;
            flex-direction: column;
            padding: 16px 20px;
            box-sizing: border-box;
            text-align: left;
            cursor: pointer;

            > :first-child {
                position: relative;
                display: flex;
                align-items: center;
                font-size: 17px;
                font-weight: 500;
                line-height: 20px;
                height: 25px;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: var(--color-main-text-primary);
            }

            > :last-child {
                position: relative;
                margin-top: 14px;
                flex: 1;
                display: flex;
                align-items: center;
                font-size: 13px;
                font-weight: 400;
                line-height: 16px;
                -webkit-line-clamp: 2;
                /* 控制显示的行数 */
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                color: var(--color-main-text-secondary);
            }
        }
    }
}
</style>
